export default __webpack_public_path__ + "static/media/logo4.ee47840f.jpg";